import * as React from 'react';
import { ProgressBar, Tab, Tabs } from 'react-bootstrap';
import { DataTiles, useCloneEntity } from 'gossamer-front-end';
import { useMyActiveTasks } from 'shared-front-end/hooks/useMyActiveTasks';
import { Task, TaskRow } from 'gossamer-model';
import styles from '../workflow/CompletedTasks.module.css';

export const Tasks = (): React.JSX.Element => {
  const taskInfo = useMyActiveTasks();
  const LocalTask = useCloneEntity(Task, (local) => {
    Object.values(local.fields).forEach((field) => {
      field.visible = false;
    });
    local.fields.label.visible = true;
  });

  const progress = taskInfo.fractionCompleted * 100;

  return (
    <Tabs variant="underline" defaultActiveKey="my-active-tasks">
      <Tab eventKey="my-active-tasks" title="My Active Tasks">
        <p>Things I need to do</p>
        <ProgressBar now={progress} />
        <br />
        <DataTiles
          entity={LocalTask}
          rows={taskInfo.activeTasks}
          hideFieldLabels={true}
          columnWidths={{ md: 6 }}
          linkTo={(row: TaskRow) => row.url}
        />
        {taskInfo.activeTasks.length === 0 && <div>You have no active tasks. Great work!</div>}
      </Tab>
      <Tab eventKey="my-completed-tasks" title="My Completed Tasks">
        <p>Tasks I have completed</p>
        <div className={styles.CompletedTasks}>
          <DataTiles
            entity={LocalTask}
            rows={taskInfo.completedTasks}
            hideFieldLabels={true}
            columnWidths={{ md: 6 }}
          />
        </div>
        {taskInfo.completedTasks.length === 0 && <div>You have no completed tasks.</div>}
      </Tab>
    </Tabs>
  );
};
